import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useNavigationManager } from '@provider/navigation';
import { useNotifier } from '@provider/notifier';
import { useUserIdentityState } from '@provider/user-identity';
import { getAllRevisionsQuery } from './query.get-all.js';
import { deactivateRevisionRequest } from './request.deactivate.js';

function useDeactivateRevisionMutation(courseId) {
  const client = useQueryClient();
  const navigationManager = useNavigationManager();
  const notifier = useNotifier();
  const user = useUserIdentityState(state => state.user);
  return useMutation(deactivateRevisionMutation(client, navigationManager, notifier, user, courseId));
}
const deactivateRevisionMutation = (client, navigationManager, notifier, user, courseId) => {
  return {
    mutationKey: ["course-revision/deactivate", user?.id, courseId],
    mutationFn: async () => await deactivateRevisionRequest(user, courseId),
    onMutate: async () => {
      const prev = client.getQueryData(getAllRevisionsQuery.queryKey({
        user,
        courseId
      }))?.find(it => it.isActive);
      client.setQueryData(getAllRevisionsQuery.queryKey({
        user,
        courseId
      }), prevRevisions => prevRevisions?.map(it => it.isActive ? {
        ...it,
        isActive: false
      } : it));

      // remove revisionId from the current URL, so we correctly reset the
      // activation when user copy + pastes URL
      const currLocation = navigationManager.getLocation();
      currLocation.searchParams.set("revisionId", "");
      currLocation.searchParams.set("revisionTitle", "");
      navigationManager.replace(`${currLocation.pathname}?${currLocation.searchParams.toString()}#${currLocation.hash.replace("#", "")}`.replace(/#$/, "").replace(/\?$/, ""));
      await client.cancelQueries({
        queryKey: getAllRevisionsQuery.queryKey({
          user,
          courseId
        })
      });
      return {
        prev
      };
    }
  };
};

export { useDeactivateRevisionMutation };
//# sourceMappingURL=mutation.deactivate.js.map
